var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M16 7.33333C16 6.8029 15.7893 6.29419 15.4142 5.91912C15.0391 5.54405 14.5304 5.33333 14 5.33333H11.3333V2C11.3333 1.46957 11.1226 0.960859 10.7475 0.585786C10.3725 0.210714 9.86377 0 9.33333 0L6.66667 0C6.13623 0 5.62753 0.210714 5.25245 0.585786C4.87738 0.960859 4.66667 1.46957 4.66667 2V5.33333H2C1.46957 5.33333 0.960859 5.54405 0.585786 5.91912C0.210714 6.29419 0 6.8029 0 7.33333L0 14.6667H1.33333V16H2.66667V14.6667H13.3333V16H14.6667V14.6667H16V7.33333ZM6 2C6 1.82319 6.07024 1.65362 6.19526 1.5286C6.32029 1.40357 6.48986 1.33333 6.66667 1.33333H9.33333C9.51014 1.33333 9.67971 1.40357 9.80474 1.5286C9.92976 1.65362 10 1.82319 10 2V5.33333H6V2ZM11.3333 9.33333H4.66667V8H11.3333V9.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.8b3cf0943489002f8c3f09359e0249d3.svg";
export { ForwardRef as ReactComponent };